import React from 'react';
import SectionTitle from '../../components/common/SectionTitle';

const FeatureImgThree = ({paddingTop}) => {
  return (
    <>
      <section className={`feature-section-two ${paddingTop?'ptb-120':'pt-60 pb-120'} `}>
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-lg-6 col-md-12'>
              <SectionTitle
                subtitle='Features'
                title='Why work with us'
                description='We’re on a mission to create a global payment ecosystem that connects businesses and consumers everywhere. We’re a leading online, mobile and point of sale payment service provider helping businesses optimise their in-store, in-app and online payments. Our team of experts tailor payment experiences customers will love while increasing conversion rates and revenue.'
              />
              <div>
                <ul className='list-unstyled mt-5'>
                  <li className='d-flex align-items-start mb-4'>
                    <div className='icon-box bg-dark rounded me-4'>
                      <i className='fas fa-file-contract text-white'></i>
                    </div>
                    <div className='icon-content'>
                      <h3 className='h5'>We're payments experts</h3>
                      <p>
                        We help you make informed decisions about your payments’ performance to manage transactions efficiently and effectively.
                      </p>
                    </div>
                  </li>
                  <li className='d-flex align-items-start mb-4'>
                      <div className='icon-box bg-primary rounded me-4'>
                        <i className='fas fa-headset text-white'></i>
                      </div>
                      <div className='icon-content'>
                        <h3 className='h5'>We're here for 24/7 support</h3>
                        <p>
                          You'll have a dedicated account manager, and technology and risk support team behind you every step of the way.
                        </p>
                      </div>
                    </li>
                  <li className='d-flex align-items-start mb-4'>
                    <div className='icon-box bg-danger rounded me-4'>
                      <i className='fas fa-person-running text-white'></i>
                    </div>
                    <div className='icon-content'>
                      <h3 className='h5'>We're agile at heart</h3>
                      <p>
                        Our range of payment integrations are constantly growing to ensure you offer your customers their preferred payment options.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-lg-6 col-md-7'>
              <div className='feature-img-wrap position-relative d-flex flex-column align-items-end'>
                <ul className='img-overlay-list list-unstyled position-absolute'>
                  <li
                    className='d-flex align-items-center bg-white rounded shadow-sm p-3'
                    data-aos='fade-right'
                    data-aos-delay='50'
                  >
                    <i className='fas fa-check bg-primary text-white rounded-circle'></i>
                    <h6 className='mb-0'>Mission</h6>
                  </li>
                  <li
                    className='d-flex align-items-center bg-white rounded shadow-sm p-3'
                    data-aos='fade-right'
                    data-aos-delay='100'
                  >
                    <i className='fas fa-check bg-primary text-white rounded-circle'></i>
                    <h6 className='mb-0'>Vision</h6>
                  </li>
                  <li
                    className='d-flex align-items-center bg-white rounded shadow-sm p-3'
                    data-aos='fade-right'
                    data-aos-delay='150'
                  >
                    <i className='fas fa-check bg-primary text-white rounded-circle'></i>
                    <h6 className='mb-0'>Accountability</h6>
                  </li>
                </ul>
                <img
                  src='assets/img/feature-img3.jpg'
                  alt='feature'
                  className='img-fluid rounded-custom'
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeatureImgThree;
